import { useRef } from "react";

import Footer from "@/base/Footer";
import { FilterPanel } from "@/search/Langston/FilterPanel";
import { SearchContentSettings } from "@/search/Langston/SearchContentSettings";
import { ContentTypeFilter } from "../ContentTypeFilter";
import { SearchResults } from "../SearchResults";
import {
  footerCss,
  mainContentsContainerCss,
  mainContentsFlexColumnCss,
  searchPageContainerCss,
} from "./SearchPage.styles";

interface SearchPageProps {
  isUniversalEmbed?: boolean;
}

export const SearchPage = ({ isUniversalEmbed = false }: SearchPageProps) => {
  const filterPanelRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div css={searchPageContainerCss}>
        <FilterPanel ref={filterPanelRef} isUniversalEmbed={isUniversalEmbed} />

        <div css={mainContentsContainerCss}>
          <div css={mainContentsFlexColumnCss}>
            <ContentTypeFilter />
            <SearchResults isUniversalEmbed={isUniversalEmbed} />
          </div>

          <Footer customCss={footerCss} />
        </div>
      </div>
      <SearchContentSettings />
    </>
  );
};
